import { variables } from "./Variables.js"
import { getToken, getRoles, getUsername } from './TokenController';

export default class AssetCreator {

    static assetTypes = [];
    

   
    async getAssetTypes(area) {
        console.log('Change area }' + area)
        var token = await getToken();
        return fetch(`${variables.API_URL}/api/assets/assettypes?area=${area}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }

        })
    }

    async getPreferedName(assettype, parent,area) {
        var token = await getToken();
        console.log(area);
       return fetch(`${variables.API_URL}/api/assets/name?parentId=${parent}&assettype=${assettype}&area=${area}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }

        })
    }

    async getPreferedFordonName(parent) {
        var token = await getToken();
       
        return fetch(`${variables.API_URL}/api/assets/name/fordon?parentId=${parent}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }

        })
    }

}